var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgSolarpiechart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:pie-chart-2-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.22199 4.601C6.66457 4.30537 7.13121 4.04746 7.61699 3.83C8.98899 3.215 9.67499 2.908 10.587 3.5C11.5 4.09 11.5 5.06 11.5 7V8.5C11.5 10.386 11.5 11.328 12.086 11.914C12.672 12.5 13.614 12.5 15.5 12.5H17C18.94 12.5 19.91 12.5 20.5 13.412C21.092 14.325 20.785 15.011 20.17 16.382C19.2909 18.3459 17.7711 19.9532 15.8594 20.9406C13.9476 21.9279 11.7573 22.237 9.64699 21.817C7.80425 21.4504 6.11158 20.5457 4.78302 19.2171C3.45447 17.8886 2.54969 16.1959 2.18309 14.3532C1.81649 12.5105 2.00453 10.6004 2.72345 8.86453C3.44236 7.12866 4.65986 5.64495 6.22199 4.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.446 7.069C21.0424 6.04754 20.4334 5.1198 19.6568 4.34318C18.8802 3.56656 17.9525 2.95761 16.931 2.554C15.389 1.947 14 3.344 14 5V9C14 9.26521 14.1054 9.51957 14.2929 9.70711C14.4804 9.89464 14.7348 10 15 10H19C20.657 10 22.053 8.61 21.446 7.069Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarpiechart);
export default __webpack_public_path__ + "static/media/solarpiechart.ba70193d4e16406fe093b79fb2266fed.svg";
export { ForwardRef as ReactComponent };